import { request } from "../utils/request";

export const getAddOnMenu = async () =>
  request(
    `${process.env.NODE_APP_PROTOCOL}://${process.env.NODE_APP_HOSTNAME}:${
      process.env.NODE_APP_PORT
    }${process.env.NODE_APP_PATHNAME}inbound/add-on`
  );
